<template>
    <div id="users">
        <h1 class="title">Пользователи</h1>
        <!-- <a role="button" aria-pressed="true" href="#" class="btn btn-secondary active" >Добавить ученика</a> -->
        <div style="margin-top: 2%; width: 40%" class="input-group mb-3">
            <div class="input-group">
                <div id="validationServerUsernameFeedback" class="invalid-feedback">
                    Заполните поле
                </div>
                <input @keyup.enter="searchUser" @click="invalid = []" ref="Sdata" type="text"
                    :class="'form-control ' + (!!~invalid.indexOf('search') ? 'is-invalid' : '')"
                    placeholder="Введите фамилию, имя, или логин" aria-describedby="basic-addon1">
                <button @click="searchUser" class="btn btn-outline-secondary" id="basic-addon1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-search" viewBox="0 0 16 16">
                        <path
                            d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0">
                        </path>
                    </svg>
                </button>
            </div>
        </div>
        <div v-if="showResults" style="display: inline-block">
            <a v-for="(user, n) in results" @click="showUser = (n + 1)" :key="user[3]" href="#">
                <h4>{{ n + 1 }}. {{ user[1] }} {{ user[0] }} ({{ user[2] }})</h4>
            </a>

            <div v-if="results.length == 0">
                <h4 style="color: #00000093;">Результаты не найдены</h4>
            </div>
        </div>
        <div v-if="showUser > 0" id="user" class="input-group mb-3">
            <div>
                <button @click="updateUser" role="button" aria-pressed="true" href="#"
                    :class="'btn btn-outline-success form-control ' + (this.saved ? 'is-valid' : '')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-floppy" viewBox="0 0 16 16">
                        <path d="M11 2H9v3h2V2Z" />
                        <path
                            d="M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0ZM1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5Zm3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4v4.5ZM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5V15Z" />
                    </svg>
                    Сохранить изменения
                </button>
                <div id="validationServerLinkFeedback" class="valid-feedback">
                    Изменения сохранены!
                </div>
            </div>
            <div style="margin-top: 2%">
                <h4><u>ФИО:</u> {{ results[showUser - 1][1] }} {{ results[showUser - 1][0] }}</h4>
                <h4><u>Логин:</u> {{ results[showUser - 1][2] }}</h4>
                <h4><u>Электронная почта:</u> <a :href="'mailto:' + results[showUser - 1][4]">{{ results[showUser -
                    1][4]
                        }}</a></h4>
                <h4><u>Номер телефона:</u> <a :href="'tel:' + results[showUser - 1][5]">{{ results[showUser - 1][5]
                        }}</a>
                </h4>
                <h4><u>Роли: </u>{{ userRoles }}</h4>
                <div class="dropdown">
                    <button data-mdb-button-init data-mdb-ripple-init data-mdb-dropdown-init
                        class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-mdb-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown">
                        Выбрать роли
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton" ref="dropdown">
                        <li v-for="j in 5" :key="j">
                            <a class="dropdown-item" href="#">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" :value="2 ** (j - 1)"
                                        :id="'role' + j" />
                                    <label class="form-check-label" :for="'role' + j">{{ roles[j - 1] }}</label>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UsersComp",
    data() {
        return {
            showResults: false,
            saved: false,
            showUser: 0,
            results: [],
            invalid: [],
            roles: ["Файлы", "Реестр компонентов", "Видеонаблюдение", "Пользователи", "Редактор новостей"]
        }
    },
    computed: {
        userRoles() {
            if (this.results[this.showUser - 1][6] == 0) {
                return "Бан"
            }
            var cRoles = []
            for (let i = 0; i < this.roles.length; i++) {
                if ((this.results[this.showUser - 1][6] >> i) & 1) {
                    cRoles.push(this.roles[i])
                }
            }
            return cRoles.join(', ')
        }
    },
    methods: {
        updateUser() {
            var role = 0
            this.saved = 0
            for (let i = 0; i < this.$refs.dropdown.children.length; i++) {
                const check = this.$refs.dropdown.children[i].firstChild.firstChild.firstChild;
                if (check.checked) {
                    role += Number(check.value)
                }
            }
            fetch("https://api.bormart.ru/edit_user", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Cookie": document.cookie
                },
                body: JSON.stringify({
                    "id": this.results[this.showUser - 1][3],
                    "role": role
                })
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data["ok"] == 1) {
                    this.saved = true
                }
            })
        },
        searchUser(inp_data) {
            var data = ''
            if (inp_data != "auto") {
                this.saved = 0
                this.invalid = []
                data = this.$refs.Sdata.value
                if (data.length == 0) {
                    this.invalid.push("search")
                    return
                }
            } else {
                data = " "
            }
            fetch("https://api.bormart.ru/search_users", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Cookie": document.cookie
                },
                body: JSON.stringify({
                    "data": data
                })
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data["ok"] == 1) {
                    this.results = data['users']
                    this.showResults = true
                }
            })
        }
    },
    mounted() {
        this.searchUser("auto")
    }
}
</script>